export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-aprovacao-entrada' */ '@/views/web-service/almoxarifado/cliente/aprovacao-entrada/Index'),
        path: 'almoxarifado-cliente-aprovacao-entrada',
        redirect: 'almoxarifado-cliente-aprovacao-entrada/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-aprovacao-entrada' */'@/views/web-service/almoxarifado/cliente/aprovacao-entrada/List.vue'),
                name: 'web-service-almoxarifado-cliente-aprovacao-entrada-index',
                path: 'index',
            },
        ],
    },
]